<template>
  <div class="cart-step d-flex align-center" :class="{ disabled: currentStep < step }">
    <router-link v-if="to && step < currentStep" class="link" :to="to" />
    <div class="step-number d-flex align-center justify-center">{{ step }}</div>
    <div class="name">
      <slot />
    </div>
    <div class="icon d-flex align-center justify-center" />
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 0
    },
    currentStep: {
      type: Number,
      default: 0
    },
    to: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.cart-step {
  position: relative;
  min-width: 180px;
  height: 40px;
  color: #007E57;
  font-size: 18px;
  font-weight: bold;
  white-space: nowrap;
  padding: 0 20px 0 12px;
  background-image:
    linear-gradient(to left, transparent 8px, currentColor 8px),
    linear-gradient(to bottom left, transparent 50%, currentColor 50%),
    linear-gradient(to top left, transparent 50%, currentColor 50%);
  background-size: 100% 100%, 8px 50%, 8px 50%;
  background-position: left top, right top, right bottom;
  background-repeat: no-repeat;

  &.disabled {
    color: #CCC;
  }

  @media screen and (max-width: 960px) {
    padding: 0 16px 0 8px;
    min-width: 0;
  }
}

.link {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.step-number {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  margin-right: 12px;
  background-color: #fff;

  @media screen and (max-width: 960px) {
    width: 20px;
    height: 20px;
    margin-right: 4px;
  }
}

.name {
  color: #fff;
}

.icon {
  margin-left: 8px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: #fff 1px solid;

  &::after {
    display: block;
    content: "";
    width: 8px;
    height: 12px;
    border-right: #fff 3px solid;
    border-bottom: #fff 3px solid;
    transform: translateY(-2px) rotate(45deg);
  }

  @media screen and (max-width: 960px) {
    width: 20px;
    height: 20px;
    margin-left: 4px;
    border: none;
  }
}
</style>
